import { cn } from 'domain/core';
import React, { forwardRef } from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

export const LinkHeader = forwardRef(
	(props: LinkProps & React.RefAttributes<HTMLAnchorElement>, ref: any) => {
		const { className, to, ...rest } = props;
		const location = useLocation();

		const match = (path: string) => {
			return (location.pathname ?? '').includes(path);
		};

		const selected = match(to.toString());
		return (
			<Link
				to={to}
				{...rest}
				ref={ref}
				className={cn(
					'flex',
					'h-full',
					'items-center',
					'border-transparent',
					'md:border-b-4',
					'truncate'
				)}>
				<span
					className={cn(
						'cursor-pointer pt-1 text-white hover:no-underline',
						'flex items-center',
						'hover:bg-primary-700',
						selected ? 'bg-primary-700' : '',
						'rounded px-2 py-1',
						className
					)}>
					{props.children}
				</span>
			</Link>
		);
	}
);

LinkHeader.displayName = 'LinkHeader';
